module.exports = __webpack_public_path__ + "bg.jO2l8RLQ.svg";